export const PRICE_TYPES = {
  MONTHLY: 'monthly',
  SEMIANNUAL: 'semiannual',
};

export const DEFAULT_CURRENCY = 'EUR';

export const PLANS = [
  {
    stripeId: process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID,
    title: 'Piano Mensile',
    subtitle: 'Conveniente',
    description: 'Abbonamento con pagamento mensile e vincolo di 6 mesi',
    price: '6,90',
    promoPrice: '4,90',
    period: PRICE_TYPES.MONTHLY,
    periodLabel: 'mese',
    features: [
      'Televideovisita con medico generico H24 illimitato',
      'Gestione appuntamenti su strutture fisiche',
      'Convenzioni su network sanitario',
      'Convenzioni su network odontoiatrico',
      'Fino a 3 famigliari inclusi oltre al sottoscrivente',
      'Attivazione immediata, potrai contattare subito il medico e ricevere assistenza medica',
    ],
  },
  {
    stripeId: process.env.REACT_APP_STRIPE_SEMIANNUAL_PRICE_ID,
    title: 'Piano Semestrale',
    subtitle: 'Più Conveniente',
    description: 'Abbonamento con pagamento unico per 6 mesi',
    price: '35',
    promoPrice: '24,90',
    discountPercentage: '15',
    period: PRICE_TYPES.SEMIANNUAL,
    periodLabel: '6 mesi',
    features: [
      'Televideovisita con medico generico H24 illimitato',
      'Gestione appuntamenti su strutture fisiche',
      'Convenzioni su network sanitario',
      'Convenzioni su network odontoiatrico',
      'Fino a 3 famigliari inclusi oltre al sottoscrivente',
      'Attivazione immediata, potrai contattare subito il medico e ricevere assistenza medica',
      'Risparmio sul prezzo mensile del 15%',
    ],
    highlighted: true,
  },
];
